/**
 * Landing Page JS — The Pemmican Project
 *
 * 1. YouTube facade (click-to-load iframe)
 * 2. Section viewport tracking (IntersectionObserver → section_view events)
 * 3. Sticky bar behaviour (show after hero, session-dismiss)
 * 4. Variant select price/availability updates
 */
(function () {
  if (window.__PemmicanLP) return;
  window.__PemmicanLP = true;

  /* -----------------------------------------------------------------------
     1. YouTube Facade
     ----------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var youtube = e.target.closest('.lp-youtube');
    if (!youtube || youtube.querySelector('iframe')) return;

    var videoId = youtube.dataset.videoId;
    if (!videoId) return;

    var iframe = document.createElement('iframe');
    iframe.src =
      'https://www.youtube-nocookie.com/embed/' +
      videoId +
      '?autoplay=1&rel=0';
    iframe.allow =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.title = youtube.dataset.videoTitle || 'Video';
    youtube.innerHTML = '';
    youtube.appendChild(iframe);
  });

  /* -----------------------------------------------------------------------
     2. Section Viewport Tracking
     ----------------------------------------------------------------------- */
  var tracked = {};
  var templateEl = document.querySelector('[data-lp-template]');
  var templateType = templateEl ? templateEl.dataset.lpTemplate : '';
  var pageSlug = window.location.pathname.replace(/^\/pages\//, '').replace(/\/$/, '') || '';

  function trackSections() {
    var sections = document.querySelectorAll('[data-lp-section]');
    if (!sections.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var key =
            el.dataset.lpSection + '-' + (el.dataset.lpPosition || '0');
          if (tracked[key]) return;
          tracked[key] = true;

          var detail = {
            section_type: el.dataset.lpSection,
            section_position: parseInt(el.dataset.lpPosition || '0', 10),
            template_type: templateType,
            page_slug: pageSlug,
          };

          window.dispatchEvent(
            new CustomEvent('section_view', { detail: detail })
          );

          if (window.dataLayer) {
            window.dataLayer.push({ event: 'section_view', ...detail });
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -----------------------------------------------------------------------
     3. Sticky Bar
     ----------------------------------------------------------------------- */
  var STICKY_KEY = 'lp-sticky-dismissed';

  function initStickyBar() {
    var bar = document.querySelector('.lp-sticky-bar');
    if (!bar) return;

    if (sessionStorage.getItem(STICKY_KEY)) {
      bar.remove();
      return;
    }

    var hero = document.querySelector('[data-lp-section="hero"]');
    if (!hero) {
      bar.classList.add('lp-sticky-bar--visible');
    } else {
      var heroObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              bar.classList.remove('lp-sticky-bar--visible');
            } else {
              bar.classList.add('lp-sticky-bar--visible');
            }
          });
        },
        { threshold: 0 }
      );
      heroObserver.observe(hero);
    }

    var dismissBtn = bar.querySelector('.lp-sticky-bar__dismiss');
    if (dismissBtn) {
      dismissBtn.addEventListener('click', function () {
        sessionStorage.setItem(STICKY_KEY, '1');
        bar.classList.remove('lp-sticky-bar--visible');
        setTimeout(function () {
          bar.remove();
        }, 300);
      });
    }
  }

  /* -----------------------------------------------------------------------
     4. Variant Select
     ----------------------------------------------------------------------- */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('.lp-variant-select')) return;

    var select = e.target;
    var option = select.options[select.selectedIndex];
    var price = option.dataset.price;
    var available = option.dataset.available === 'true';

    var section = select.closest('[data-lp-section]');
    if (!section) return;

    var priceEl = section.querySelector('[data-lp-price]');
    if (priceEl && price) {
      priceEl.textContent = price;
    }

    var hiddenInput = select.closest('form')
      ? select.closest('form').querySelector('input[name="id"]')
      : null;
    if (hiddenInput) {
      hiddenInput.value = select.value;
    }

    var atcBtn = select.closest('form')
      ? select.closest('form').querySelector('[type="submit"]')
      : null;
    if (atcBtn) {
      atcBtn.disabled = !available;
      atcBtn.textContent = available
        ? atcBtn.dataset.addText || 'Add to cart'
        : 'Sold out';
    }
  });

  /* -----------------------------------------------------------------------
     5. Initialise
     ----------------------------------------------------------------------- */
  function init() {
    trackSections();
    initStickyBar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify editor section load
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function () {
      trackSections();
      initStickyBar();
    });
  }
})();
